import {getRequest} from "@requests/index";
import {prepareSetRows} from "@helpers/functions";
import {store} from "./../redux/store";

export function getDocuments(docType) {
    const {apiDomainVikon} = store.getState();
    let chainPromises = [
        getRequest(`${apiDomainVikon}api/digital_profile/document_schemes/group/${docType}`),
        getRequest(`${apiDomainVikon}/api/digital_profile/applicant/group_documents/${docType}`, {
            detail: true,
            apiDomainVikon
        }),
    ];
    return Promise.all(chainPromises).then(values => {
        const [documentSchemes, documents] = values;
        if (!documentSchemes.errors) {
            let types = [];
            let schemes = [];
            documentSchemes.forEach(documentScheme => {
                types.push({
                    id: documentScheme.doc_type,
                    value: documentScheme.doc_name,
                    value_en: documentScheme.doc_name_en
                });
                schemes[documentScheme.doc_type] = documentScheme;
            });
            let documentsPrepare = [];
            if (!documents.errors) {
                documentsPrepare = prepareSetRows(documents, {empty_add: true});
            }
            return [types, schemes, documentsPrepare];
        }
    });
}
export function getDocumentsRepeat(docType) {
    const {apiDomainVikon} = store.getState();
    return getRequest(`${apiDomainVikon}/api/digital_profile/applicant/group_documents/${docType}`, {
        detail: true,
        apiDomainVikon
    })
        .then(documents => {
            let documentsPrepare = [];
            if (!documents.errors) {
                documentsPrepare = prepareSetRows(documents, {empty_add: true});
            }
            return documentsPrepare;
        });
}